import { render, staticRenderFns } from "./PassengerInformationEditor.vue?vue&type=template&id=8cf690e2"
import script from "./PassengerInformationEditor.vue?vue&type=script&lang=js"
export * from "./PassengerInformationEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports